import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LandingPage from './page/users/landingPage';
import Home from './page/users/home';
import IsiSaldo from './page/users/isiSaldo';
import SearchPage from './page/users/searchPage';
import DetailSearch from './page/users/detailSearch';
import ShopPage from './page/users/shopPage';
import TrollyPage from './page/users/trolly';
import Checkout from './page/users/checkout';
import ProfilePage from './page/users/profile';
import Logout from './page/logout';
import UpdateEmailPage from './page/users/updateEmailPage';
import UpdatePasswordPage from './page/users/updatePasswordPage';

import SellerLogin from './page/sellers/sellerLogin';
import SellerDashboard from './page/sellers/sellerDashboard';
import SellerListTrans from './page/sellers/sellerListTrans';
import SellerToko from './page/sellers/sellerToko';
import SellerAddProduk from './page/sellers/sellerAddProduk';
import SellerUpdateProduk from './page/sellers/sellerUpdateProduk';
import SellerProduk from './page/sellers/sellerProduk';
import SellerPesanan from './page/sellers/sellerPesanan';
import SellerUpdateEmailPage from './page/sellers/sellerUpdateEmailPage';
import SellerUpdatePassword from './page/sellers/sellerUpdatePassword';

import AdminLogin from './page/admin/adminLogin';
import AdminDashboard from './page/admin/adminDashboard';
import AdminDaftarToko from './page/admin/adminToko';
import AdminDaftarUser from './page/admin/adminUser';
import AdminDaftarProduk from './page/admin/adminProduk';
import AdminListTrans from './page/admin/adminListTrans';

import "./App.css"

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<LandingPage></LandingPage>} />
        <Route path='/home' element={<Home></Home>} />
        <Route path='/isiSaldo' element={<IsiSaldo></IsiSaldo>} />
        <Route path='/search' element={<SearchPage></SearchPage>} />
        <Route path='/search/detailSearch/:id' element={<DetailSearch></DetailSearch>} />
        <Route path='/shopPage/:id' element={<ShopPage></ShopPage>} />
        <Route path='/trolly' element={<TrollyPage></TrollyPage>} />
        <Route path='/checkout' element={<Checkout></Checkout>} />
        <Route path='/userProfile' element={<ProfilePage></ProfilePage>} />
        <Route path='/updateEmail' element={<UpdateEmailPage></UpdateEmailPage>} />
        <Route path='/updatePassword' element={<UpdatePasswordPage></UpdatePasswordPage>} />

        <Route path='/sellerLogin' element={<SellerLogin></SellerLogin>} />
        <Route path='/sellerDashboard' element={<SellerDashboard></SellerDashboard>} />
        <Route path='/sellerDashboard/transactions' element={<SellerListTrans></SellerListTrans>} />
        <Route path='/sellerToko' element={<SellerToko></SellerToko>} />
        <Route path='/sellerProduct' element={<SellerProduk></SellerProduk>} />
        <Route path='/sellerProduct/add' element={<SellerAddProduk></SellerAddProduk>} />
        <Route path='/sellerProduct/:id' element={<SellerUpdateProduk></SellerUpdateProduk>} />
        <Route path='/sellerPesanan' element={<SellerPesanan></SellerPesanan>} />
        <Route path='/seller/updateEmail' element={<SellerUpdateEmailPage></SellerUpdateEmailPage>} />
        <Route path='/seller/updatePassword' element={<SellerUpdatePassword></SellerUpdatePassword>} />

        <Route path='/adminLogin' element={<AdminLogin></AdminLogin>} />
        <Route path='/adminDashboard' element={<AdminDashboard></AdminDashboard>} />
        <Route path='/adminToko' element={<AdminDaftarToko></AdminDaftarToko>} />
        <Route path='/adminUser' element={<AdminDaftarUser></AdminDaftarUser>} />
        <Route path='/adminProduk' element={<AdminDaftarProduk></AdminDaftarProduk>} />
        <Route path='/adminDashboard/transactions' element={<AdminListTrans></AdminListTrans>} />

        <Route path='/logout' element={<Logout></Logout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
